import { call, put, spawn } from 'redux-saga/effects'
import {
  countriesApiService,
  handleError,
  handleSuccess,
} from 'Services/ApiService'
import CountriesActions from 'Stores/Country/Actions'
import { encodeObjectToBase64 } from 'Utils/Base64Functions'
import i18n from 'i18next'

export function* fetchCountriesList({ filter, offset, shouldShowError }) {
  try {
    if (filter != null) {
      filter = encodeObjectToBase64(filter)
    }
    if (offset === 0) {
      yield put(CountriesActions.fetchCountriesListLoading())
    }
    const { data } = yield call(countriesApiService.get, '/', {
      params: {
        filter: filter,
        offset: offset,
      },
    })
    yield put(
      CountriesActions.fetchCountriesListSuccess(
        offset,
        data.countries,
        data.nextOffset,
      ),
    )
  } catch (e) {
    yield put(CountriesActions.fetchCountriesListFail(e))
    if (!shouldShowError) handleError(e)
  }
}
export function* fetchCountriesListCount({ filter }) {
  yield put(CountriesActions.fetchCountriesListCountLoading())
  try {
    if (filter != null) {
      filter = encodeObjectToBase64(filter)
    }
    const { data } = yield call(countriesApiService.get, '/count', {
      params: {
        filter: filter,
      },
    })
    yield put(
      CountriesActions.fetchCountriesListCountSuccess(data.countriesCount),
    )
  } catch (e) {
    yield put(CountriesActions.fetchCountriesListCountFail(e))
    handleError(e)
  }
}

export function* addCountry({ country }) {
  try {
    yield put(CountriesActions.addCountryLoading())
    const { data } = yield call(countriesApiService.post, '/', {
      name: country.countryName,
      codeTwoLetters: country.countryCode,
      currency: country.countryCurrency,
    })
    yield put(CountriesActions.addCountrySuccess(data.country))
    handleSuccess(i18n.t('CountriesPage.AddCountrySuccessMessage'))
  } catch (e) {
    yield put(CountriesActions.addCountryFail(e))
    handleError(e)
  }
}
